import { render } from "./LookUpValues.vue?vue&type=template&id=66b13042&scoped=true&ts=true"
import script from "./LookUpValues.vue?vue&type=script&lang=ts"
export * from "./LookUpValues.vue?vue&type=script&lang=ts"

import "./LookUpValues.vue?vue&type=style&index=0&id=66b13042&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b13042"]])

export default __exports__